"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var VideoStream_1 = __importDefault(require("./VideoStream"));
var VideoMuted_1 = __importDefault(require("./VideoMuted"));
var Pin_1 = __importDefault(require("./Pin"));
var AudioStream_1 = __importDefault(require("./AudioStream"));
var useMobile_1 = __importDefault(require("./hooks/useMobile"));
var TileBar_1 = __importDefault(require("./TileBar"));
function RemoteVideo(_a) {
    var _b = _a.canPin, canPin = _b === void 0 ? false : _b, children = _a.children, // any other children to e placed in the container
    _c = _a.containerStyle, // any other children to e placed in the container
    containerStyle = _c === void 0 ? {} : _c, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'remote-video' : _d, _e = _a.isPresentationPip, isPresentationPip = _e === void 0 ? false : _e, _f = _a.metadata, metadata = _f === void 0 ? {} : _f, _g = _a.mirror, mirror = _g === void 0 ? false : _g, _h = _a.muted, muted = _h === void 0 ? false : _h, onClick = _a.onClick, onHover = _a.onHover, _j = _a.showMetadata, showMetadata = _j === void 0 ? false : _j, stream = _a.stream, streamId = _a.streamId, _k = _a.videoStyle, videoStyle = _k === void 0 ? {} : _k;
    var _l = react_1.useState(false), showPin = _l[0], setShowPin = _l[1];
    var audioOnly = metadata.videoPaused || metadata.videoMuted;
    var isIOS = useMobile_1.default().isIOS;
    var name = metadata.displayName || metadata.name;
    var composedContainerStyle = __assign(__assign({}, containerStyle), { justifyContent: 'center' });
    if (audioOnly) {
        delete videoStyle['backgroundColor'];
    }
    var composedVideoStyles = __assign(__assign({}, videoStyle), { borderRadius: '5px', display: audioOnly ? 'none' : 'block' });
    var onMouseEnter = function () {
        setShowPin(true);
        onHover && onHover(true);
    };
    var onMouseLeave = function () {
        setShowPin(false);
        onHover && onHover(false);
    };
    return (react_1.default.createElement("div", { "data-testid": dataTestId, style: composedContainerStyle, onClick: function (e) { return (onClick ? onClick(e) : {}); }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        audioOnly && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(VideoMuted_1.default, { displayName: name, style: __assign({}, videoStyle) }),
            !isIOS && !muted && react_1.default.createElement(AudioStream_1.default, { mediaStream: stream }))),
        react_1.default.createElement(VideoStream_1.default, { containPortrait: isPresentationPip ? false : true, elementId: "remoteStream-" + streamId, hidden: audioOnly, mediaStream: stream, mirror: mirror, muted: muted || (audioOnly && !isIOS), style: composedVideoStyles }),
        children,
        showMetadata && react_1.default.createElement(TileBar_1.default, { show: showMetadata, metadata: metadata }),
        (!!name && canPin) && react_1.default.createElement(Pin_1.default, { participantId: metadata.participantId, visible: showPin })));
}
exports.default = RemoteVideo;
